import React from 'react';
import { useSelector } from 'react-redux';
import CardsGridCSpaces from '@src/components/CardsGrid/connectors/spaces';
import PagingCSpaces from '@src/components/Paging/connectors/spaces';
import SuggestionsCDefault from '@src/components/Suggestions/connectors/default';
import RecentCDefault from '@src/components/Recent/connectors/default';
import SorterCSpaces from '@src/components/Sorter/connectors/spaces';
import TagFilters from '@src/components/TagFilters/connectors/default';
import getViewed from '@src/containers/Session/selectors/getViewed';
import getFiltersQuery from '@src/containers/Filters/selectors/getFiltersQuery';
import { getTitles } from '@src/containers/Session/selectors/getTitles';
import LinkLinesCCatalog from '@src/components/LinkLines/connectors/LinkLinesCCatalog';

import ListingPage from '..';

const ListingPageCDefault = () => {
	const { spaces } = useSelector(getViewed);
	const filters = useSelector(getFiltersQuery);
	const { h1, h1Text } = useSelector(getTitles);

	return (
		<ListingPage
			CardGrid={CardsGridCSpaces}
			Paging={PagingCSpaces}
			Suggestions={filters.spec ? undefined : SuggestionsCDefault}
			Recent={spaces.length > 0 ? RecentCDefault : null}
			Sorter={SorterCSpaces}
			Filters={TagFilters}
			title={h1}
			description={h1Text}
			LinkLines={LinkLinesCCatalog}
		/>
	);
};

export default ListingPageCDefault;
